import { Modal, InputNumber, Button, Space, message, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import { useMainContext } from '../../hooks/useMainContext';
import Draggable from 'react-draggable';
import { TbX, TbArrowsMove } from 'react-icons/tb';

const LengthInputForm = observer(({ visible, onSubmit, onCancel }) => {
    const { closetManager, drawingManager } = useMainContext();
    const [feet, setFeet] = useState('');
    const [inches, setInches] = useState('');
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        if (closetManager.calibrationData.length === 2) {
            setModalPosition({ x: 0, y: 0 });
        }
    }, [closetManager.calibrationData.length]);

    const handleSubmit = () => {
        const feetNum = 0;
        const inchesNum = parseFloat(inches) || 0;

        if (feetNum <= 0 && inchesNum <= 0) {
            message.error('Feet and inches cannot both be zero or negative.');
            return;
        }

        onSubmit(feetNum, inchesNum);
        setFeet('');
        setInches('');
        onCancel();
    };

    const handleCancel = () => {
        setFeet('');
        setInches('');
        closetManager.setCanCalibrate(false);
        drawingManager.setCalibrationMode(false);
        closetManager.setCalibrationData([]);
        closetManager.drawNewClosets();
        onCancel();
    };

    return (
        <Modal
            className="length-input-form-modal"
            open={closetManager.calibrationData.length === 2}
            footer={null}
            width={500}
            styles={{
                content: {
                    padding: '32px',
                    borderRadius: '32px',
                },
            }}
            modalRender={(modal) => (
                <Draggable
                    handle=".drag-button"
                    cancel=".ant-input-number, .ant-btn:not(.drag-button)"
                    position={modalPosition}
                    onStop={(_, data) => {
                        setModalPosition({ x: data.x, y: data.y });
                    }}>
                    <div>{modal}</div>
                </Draggable>
            )}
            centered
            closable={false}>
            <div
                className="border-b-[1px] border-theme-border pb-2"
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10,
                }}>
                <Typography.Title
                    level={4}
                    style={{
                        margin: 0,
                        fontSize: '32px',
                        lineHeight: '40px',
                        color: '#000000',
                    }}>
                    Set Calibration Length
                </Typography.Title>
                <div style={{ display: 'flex' }}>
                    <Button
                        className="drag-button flex items-center justify-center p-0 w-[32px] h-[32px]"
                        style={{ cursor: 'move', border: 'none' }}>
                        <TbArrowsMove size={20} />{' '}
                    </Button>
                    <Button
                        type="text"
                        className="flex items-center justify-center p-0 w-[32px] h-[32px]"
                        onClick={handleCancel}>
                        <TbX size={20} />
                    </Button>
                </div>
            </div>
            <Space direction="vertical" style={{ width: '100%' }}>
                <div className="flex  gap-[8px] flex-col">
                    <span className="text-[16px] font-favorit font-[700] leading-[24px] shrink-0">
                        Inches
                    </span>
                    <InputNumber
                        addonAfter={'"'}
                        className="number-input"
                        min={0}
                        placeholder="Inches"
                        value={inches}
                        onChange={(value) => setInches(value)}
                    />
                </div>
                <Space style={{ marginTop: 8 }} className="flex justify-end">
                    <Button
                        type="primary"
                        className="bg-theme-orange text-theme-white !rounded-[36px] text-[16px] w-[140px] h-[40px] !!hover:bg-theme-orange-hover !shadow-none save-changes-button"
                        onClick={handleSubmit}>
                        Submit
                    </Button>
                    {/* <Button
                        onClick={handleCancel}
                        variant="primary"
                        className="bg-theme-button-bg close-button">
                        Close
                    </Button> */}
                </Space>
            </Space>
        </Modal>
    );
});

export default LengthInputForm;
